import React, { useCallback, useEffect, useState } from 'react'
import { Calculator as CalculatorType } from '../types/Calculator'
import { CalculatorOutput } from '../types/CalculatorOutput'
import { CalculatorStep } from '../types/CalculatorStep'
import { Step } from './Step'
import { Totals, _Total } from './Totals'

interface LooseObject {
  [key: string]: any
}

const Calculator = ( { calculator }:Props ) => {

  const [ totals, setTotals ] = useState<_Total[]>( () => {
    const currentTotals:_Total[] = []
    calculator.steps.map( 
        step => step.outputs.filter( 
          out => out.visible === true
        ).forEach( out => {
          currentTotals.push( {
            label: out.name,
            value: 0,
            output: out
          } )
        }) 
    )

    return currentTotals
  })
  const [ , setFullData ] = useState<LooseObject>({})
  const [ activeStepOutputTargets, setActiveStepOutputTargets ] = useState<string[]>( [] )
  const getExpression = useCallback( ( output:CalculatorOutput, step: CalculatorStep, fullData:any ) => {
    let expression = output.calc ?? '0+0'
    const keys = Array.from( expression.matchAll( new RegExp(/{{([^}]*)}}/g) ) )
    keys?.forEach( ( [ replace, attribute ] ) => {
      if( !fullData[attribute] ) return 
      const valueStr:string = fullData[attribute]
      const input =  step.inputs.find( i => i.id === attribute )
      const value = parseFloat( valueStr )
      expression = expression.replace( replace,  ( input?.sufix === '%' ? value / 100 : value ).toString() )
    })
    return expression
  }, [] )

  const updateData = useCallback( () => {
    calculator.steps.forEach( step => step.outputs.forEach( out => {
        setFullData( currentData => {
          try {
            // eslint-disable-next-line
            const val = eval( getExpression( out, step, currentData ) ) 
            const _val = parseFloat( val )

            try {
              setTotals( currentTotals => {
                return [
                  ...currentTotals.filter( t => t.output?.id !== out.id ),
                  {
                    label: out.name,
                    value: _val,
                    output: out
                  }
                ]
              } )
              
            } catch (error) { }

            const obj:LooseObject = Object.fromEntries([
              [
                out.id,
                _val
              ]
            ])
            return { ...currentData, ...obj }
          } catch (error) { }
          
          return currentData
        })
    }) )
  }, [ calculator, getExpression ] )

  const handleStepChange = useCallback( ( data:any  ) => {
    setFullData( prev => ( { ...prev, ...data } ) )
    updateData()
  }, [ updateData ] )

  const handleStepFocus = useCallback( ( step:CalculatorStep ) => {
    setActiveStepOutputTargets( step.targets ?? [] )
  }, [] )

  useEffect( () => {
    updateData()
  }, [ updateData ] )

  return ( 
    <div className="grid grid-cols-12 gap-4 md:gap-8 mt-10 relative font-fira p-4 pb-16 md:pb-4 md:py-0">
      <div className="col-span-12 md:col-span-7">
        { 
          calculator.steps.map( step => 
            <Step 
              key={ step.id } 
              step={ step } 
              onChange={ handleStepChange }
              onFocus={ handleStepFocus }
            /> 
          )
        }
      </div>
      <div className="col-span-12 md:col-span-5">
        <Totals 
          totals={ totals }
          activeTargets={ activeStepOutputTargets }
          calculator={ calculator }
        />
      </div>
    </div>
  )
}

interface Props {
  calculator: CalculatorType
}

export { Calculator }
